module.exports = __webpack_public_path__ + "static/media/img_22.7dc47f48.png";